import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
              视频分类
            </h2>
            <p className="text-foreground-500 text-sm">四大频道，满足您对国产精品视频的所有需求</p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-lg p-6 md:p-8 text-center border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                  <i className={`${getCategoryIcon(cat.slug)} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2 font-heading">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{cat.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function getCategoryIcon(slug: string): string {
  switch (slug) {
    case 'jq': return 'ri-movie-2-line';
    case 'jl': return 'ri-camera-lens-line';
    case 'zy': return 'ri-live-line';
    case 'dp': return 'ri-clapperboard-line';
    default: return 'ri-play-circle-line';
  }
}